import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthGuardService } from "./auth-guard.service";
@Injectable({
  providedIn: "root",
})
export class TrafficsService {
  protected bookingimageurl: BehaviorSubject<string>;
  constructor(
    private http: HttpClient,
    private authGuardService: AuthGuardService
  ) {
    this.bookingimageurl = new BehaviorSubject("");
  }

  request(obj, suffix: string): Observable<any> {
    obj.partnerid = this.authGuardService.getPartnerId();
    obj.licence = this.authGuardService.getPartnerLicense();
    obj.giatalicence = this.authGuardService.getGiataLicense();
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "ngsw-bypass": "",
      }),
    };
    return this.http
      .post("api/trafics/" + suffix, { body: obj }, httpOptions)
      .pipe(catchError((res) => of(res)));
  }

  get bookingimageurl$() {
    return this.bookingimageurl.asObservable();
  }

  setbookingimageurl(url) {
    this.bookingimageurl.next(url);
  }
}
